import { createSlice } from '@reduxjs/toolkit'

import { QuoteData, SwapData, SwapRequestStatus } from './type'

type QuoteResponse = { data: QuoteData[]; error: string; status: SwapRequestStatus }
type SwapResponse = { data: SwapData[]; error: string; status: SwapRequestStatus }

type SwapState = {
  quote?: QuoteResponse
  swap?: SwapResponse
}

const initialState: SwapState = {
  quote: { data: [], error: null, status: null },
  swap: { data: [], error: null, status: null },
}

export const swapDataRequested = (state) =>
  state.swap.swap?.status === SwapRequestStatus.Requesting || state.swap?.quote.status === SwapRequestStatus.Requesting

export const sliceSwap = createSlice({
  initialState,
  name: 'swap',
  reducers: {
    resetSwapData: (state) => {
      state.quote = initialState.quote
      state.swap = initialState.swap
    },
    setQuote: (state, { payload }) => {
      state.quote = payload
    },
    setSwap: (state, { payload }) => {
      state.swap = payload
    },
  },
})

export const { resetSwapData, setQuote, setSwap } = sliceSwap.actions
